@if (showSpinner) {
<app-loader> </app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  @if (isavailablefeature('isView')) {
  <div class="container-fluid mb-4 px-4">
    <div class="holiday-top align-items-center mt-3 mb-4">
      <div class="holiday-heading">
        <h1>PUBLIC HOLIDAYS</h1>
      </div>
      @if (isavailablefeature('isAdd')) {
      <button class="holiday-btn ml-auto mt-3 mt-md-0 px-4 py-2" (click)="openModal()">
        <img src="../../../assets/images/apply-leave-icon.svg" alt="" class="pr-2">
        ADD HOLIDAY
      </button>
      }
    </div>

    <!-- Grid View -->
    <div class="holiday-grid mt-4">
      @for (item of holidays; track item; let i = $index) {
      <div class="holiday-card" [style.animation-delay]="(i * 0.05) + 's'"
        [ngClass]="{ 'dark-card': selectedMode === 'dark' }">

        <div class="card-accent" [style.background-color]="getItemColor(i)"></div>

        <div class="card-content">
          <div class="holiday-name" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">{{ item.day_name }}</div>
          <div class="holiday-full-date">
            <i class="far fa-calendar-alt" [style.color]="getItemColor(i)"></i>
            @if (!item.isRange) {
            {{ getMonth(item.startDate) }} {{ getDay(item.startDate) }}
            } @else {
            {{ getMonth(item.startDate) }} {{ getDay(item.startDate) }} -
            @if (getMonth(item.startDate) !== getMonth(item.endDate)) {
            {{ getMonth(item.endDate) }}
            }
            {{ getDay(item.endDate) }}
            }
          </div>
        </div>

        <div class="card-footer" [style.border-top-color]="getItemColor(i) + '33'">
          <div class="footer-date" [style.color]="getItemColor(i)">
            @if (!item.isRange) {
            <span class="footer-day">{{getDay(item.startDate)}}</span>
            <span class="footer-month">{{getMonth(item.startDate).substring(0, 3)}}</span>
            } @else {
            <span class="footer-day">{{getDay(item.startDate)}} - {{getDay(item.endDate)}}</span>
            <span class="footer-month">
              {{getMonth(item.startDate).substring(0, 3)}}
              @if (getMonth(item.startDate) !== getMonth(item.endDate)) {
              / {{getMonth(item.endDate).substring(0, 3)}}
              }
            </span>
            },
            {{getYear(item.startDate)}}
          </div>
        </div>
      </div>
      }
    </div>
  </div>
  }

  <!-- Modal Overlay -->
  @if (showHolidayModal) {
  <div class="modal-overlay" (click)="closeModal()">
    <div class="modal-container" (click)="$event.stopPropagation()">
      <app-holiday-form (holidaySaved)="handleHolidaySaved()" (cancel)="closeModal()">
      </app-holiday-form>
    </div>
  </div>
  }
</main>